import $ from 'jquery';
import 'slick-carousel';

const defaults = {
  centerMode: true,
  centerPadding: '200px',
  slidesToShow: 1,
  autoplay: false,
  variableWidth: true,
  prevArrow: '<button type="button" class="slick-prev">Previous</button>',
  nextArrow: '<button type="button" class="slick-next">Next</button>',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1,
      },
    },
  ],
};

export default class GallerySlider {
  constructor(element, options) {
    this.element = element;
    this.$element = $(element);
    this.settings = { ...defaults, ...options };
    this.$gallery = this.build();
    this.ready();
  }

  build() {
    return this.$element.slick(this.settings);
  }

  ready() {
    this.$element.addClass('ready');
  }
}
